import { useParams } from 'react-router-dom';
import { FirstLoginContent } from './FirstLoginContent';

export default function FirstLoginPage() {
    const token: string | undefined = useParams().token;
    if (token === undefined) {
        throw new Error('First-login token is required');
    }
    return <FirstLoginContent token={token} />;
}
